import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import "./AddProjectFundForm.css";

const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL;

export default function AddProjectFundForm() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!amount || Number(amount) <= 0) {
      return setError("Please enter a valid amount.");
    }

    try {
      setLoading(true);
      setError(null);

      const res = await axios.put(
        `${API_BASE_URL}/projects/${id}/add-fund`,
        { amount: Number(amount) }
      );

      // Show success alert
      alert(res.data.message || "Fund added successfully!");

      // Go back to previous page
      navigate(-1);

    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Failed to add fund. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-fund-page">
      <motion.div
        className="add-fund-card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        {/* 🔙 Back Button */}
        <button
          type="button"
          className="back-btn"
          onClick={() => navigate(-1)}
        >
          ← Back
        </button>

        <h2>Add Fund to Project</h2>

        <form onSubmit={handleSubmit}>
          <label>Amount (GHS)</label>
          <input
            type="number"
            placeholder="Enter amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />

          <motion.button
            type="submit"
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            disabled={loading}
          >
            {loading ? "Processing..." : "Add Fund"}
          </motion.button>
        </form>

        {error && <div className="error-msg">{error}</div>}
      </motion.div>
    </div>
  );
}
